import { useUIGameEndContext } from '../../../../contexts/UIGameEndContext.tsx';
import React, { useMemo } from 'react';
import styles from './PlayerTable.module.scss';
import { Avatar } from '../../../../common/Avatar/index.ts';
import clsx from 'clsx';
import { LocationFlag, T, Tooltip } from '@colonist/ui';
import { UIGamePlayerOptionsDropdown } from '../../../../common/UIGamePlayerOptionsDropdown/index.ts';
import IconTrophy from '@static/images/icon_trophy.svg';
import { useGameStore } from '../../../../store/GameStoreContext.ts';
import { usePlayerValidators } from '../../../../store/selectors/usePlayerValidators.ts';
const Player = ({ player })=>{
    const isRanked = useGameStore((state)=>state.gameDetails.isRanked);
    const { getPlayerValidator } = usePlayerValidators();
    const playerValidator = getPlayerValidator(player.color);
    const isCurrentUser = playerValidator.isCurrentUser;
    const shouldUseDiscordProxyForLocationFlag = useGameStore((state)=>state.gameClientConfig.shouldUseDiscordProxyForLocationFlag);
    const gameOrientation = useGameStore((state)=>state.gameClientConfig.gameOrientation);
    const friendUsernames = useGameStore((state)=>state.gameClientConfig.friendUsernames);
    const onClickMembershipIcon = useGameStore((state)=>state.gameClientConfig.onClickMembershipIcon);
    const shouldShowCountryFlag = useMemo(()=>{
        if (!isRanked) return false;
        if ((playerValidator === null || playerValidator === void 0 ? void 0 : playerValidator.userState.regionUpdated) != undefined) return true;
        if (playerValidator === null || playerValidator === void 0 ? void 0 : playerValidator.isPlayingOnDiscord) return false;
        if ((playerValidator === null || playerValidator === void 0 ? void 0 : playerValidator.userState.countryCode) == null) return false;
        return true;
    }, [
        isRanked,
        playerValidator
    ]);
    if (playerValidator.userState.isBot) {
        return /*#__PURE__*/ React.createElement("div", {
            className: styles.playerInfo
        }, /*#__PURE__*/ React.createElement(Avatar, {
            className: styles.avatar,
            color: player.color,
            image: playerValidator.userState.databaseIcon
        }), /*#__PURE__*/ React.createElement("div", {
            className: clsx(styles.name, styles.botName)
        }, playerValidator.username));
    }
    const isFriend = friendUsernames.includes(playerValidator.username);
    const showPlusIcon = !(gameOrientation == 'portrait' || playerValidator.isLocalDiscordPlayer || playerValidator.userState.isBot || isCurrentUser || isFriend);
    return /*#__PURE__*/ React.createElement(UIGamePlayerOptionsDropdown, {
        className: styles.playerInfo,
        excludeOptions: [
            'blockTrades',
            'mute'
        ],
        shouldOpenSendGiftPageInternally: true,
        playerValidator: playerValidator
    }, /*#__PURE__*/ React.createElement(Avatar, {
        className: styles.avatar,
        color: player.color,
        image: playerValidator.userState.databaseIcon,
        membership: playerValidator.userState.membership,
        onMembershipClick: onClickMembershipIcon,
        profilePictureUrl: playerValidator.userState.profilePictureUrl,
        showPlusIcon: showPlusIcon
    }), /*#__PURE__*/ React.createElement("div", {
        className: styles.name
    }, playerValidator.username), shouldShowCountryFlag && /*#__PURE__*/ React.createElement(LocationFlag, {
        className: styles.flag,
        location: {
            countryCode: playerValidator.userState.countryCode
        },
        isUserOnDiscord: shouldUseDiscordProxyForLocationFlag
    }));
};
export const PlayerTable = ()=>{
    const { playersByRank } = useUIGameEndContext();
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.row
    }, /*#__PURE__*/ React.createElement("div", null), /*#__PURE__*/ React.createElement(Tooltip, {
        centerText: true,
        title: /*#__PURE__*/ React.createElement(T, {
            id: {
                key: 'strings:game.endGame.icons.trophy'
            }
        })
    }, /*#__PURE__*/ React.createElement("img", {
        className: styles.trophyIcon,
        src: IconTrophy
    }))), playersByRank.map((player)=>/*#__PURE__*/ React.createElement("div", {
            className: styles.row,
            key: player.color
        }, /*#__PURE__*/ React.createElement(Player, {
            player: player
        }), /*#__PURE__*/ React.createElement("div", {
            className: styles.victoryPoint
        }, player.totalVictoryPoints))));
};
